import React from 'react';
import Button from './Button';
import Badge from './Badge';
import { ArrowLeft, Calendar, Sparkles } from 'lucide-react';
import decodeHtml from '../utils/decodeHtml';

// Fonction pour formater la date du dernier audit
const formatLastAudit = (dateString) => {
  if (!dateString) return 'Jamais audité';
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Hier';
    if (diffDays <= 7) return `Il y a ${diffDays} jours`;
    if (diffDays <= 30) return `Il y a ${Math.floor(diffDays / 7)} semaine${Math.floor(diffDays / 7) > 1 ? 's' : ''}`;
    if (diffDays <= 365) return `Il y a ${Math.floor(diffDays / 30)} mois`;
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch {
    return 'Date inconnue';
  }
};

export default function ProjectHeader({ project, onBack, onAudit, auditLoading, extraButton, positionAnalyseButton }) {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-8 px-0 pb-4 w-full">
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <Button onClick={onBack} variant="secondary" className="text-gray-500 hover:text-gray-700 font-light px-2 py-1">
          <ArrowLeft size={20} />
        </Button>
        <img src={project.favicon_url} alt="favicon" className="w-8 h-8 rounded-xl bg-white border border-blue-100 shadow-sm ml-4" />
        <div className="flex flex-col min-w-0">
          <div className="font-heading text-xl font-extrabold text-blue-gray-900 truncate">{decodeHtml(project.name)}</div>
          <div className="flex items-center gap-2 text-blue-gray-400">
            <span className="truncate text-xs">www.{project.name}</span>
            <span className="mx-2">•</span>
            <Calendar size={16} className="inline-block mr-1" />
            <span className="text-xs">{formatLastAudit(project.date_dernier_audit)}</span>
            {project.audit_status === 'done' && (
              <Badge color="success" className="ml-2 flex items-center gap-1"><Sparkles size={16} /> Terminé</Badge>
            )}
          </div>
        </div>
      </div>
      {(onAudit || extraButton || positionAnalyseButton) && (
        <div className="flex flex-col md:flex-row gap-3 items-center md:items-end mt-4 md:mt-0">
          {extraButton && (
            <Button
              variant="secondary"
              className="text-base px-5 py-2 flex items-center gap-2"
              onClick={extraButton.onClick}
              disabled={extraButton.disabled || extraButton.loading}
            >
              {extraButton.loading ? 'Analyse en cours...' : extraButton.label}
            </Button>
          )}
          {positionAnalyseButton && (
            <Button
              variant="secondary"
              className="text-base px-5 py-2"
              onClick={positionAnalyseButton.onClick}
              disabled={positionAnalyseButton.disabled || positionAnalyseButton.loading}
            >
              {positionAnalyseButton.loading ? 'Analyse en cours...' : positionAnalyseButton.label}
            </Button>
          )}
          {onAudit && (
            <Button variant="primary" className="text-base px-6 py-2 flex items-center gap-2" onClick={onAudit} disabled={auditLoading}>
              <Sparkles size={18} /> {auditLoading ? 'Audit en cours...' : 'Lancer un audit complet'}
            </Button>
          )}
        </div>
      )}
    </div>
  );
} 